import apiClient from "@/lib/api";

const SETTINGS_BASE_PATH = "/admin/settings";

const request = async (config) => {
  const response = await apiClient(config);
  return response.data;
};

const get = (path, params) =>
  request({
    url: path,
    method: "get",
    params,
  });

const post = (path, data) =>
  request({
    url: path,
    method: "post",
    data,
  });

const patch = (path, data) =>
  request({
    url: path,
    method: "patch",
    data,
  });

const remove = (path) =>
  request({
    url: path,
    method: "delete",
  });

export const listCollabAccess = () => get(`${SETTINGS_BASE_PATH}/collab-access`);
export const createCollabAccess = (payload) => post(`${SETTINGS_BASE_PATH}/collab-access`, payload);
export const updateCollabAccess = (id, payload) =>
  patch(`${SETTINGS_BASE_PATH}/collab-access/${id}`, payload);
export const deleteCollabAccess = (id) => remove(`${SETTINGS_BASE_PATH}/collab-access/${id}`);
export const blockCollabAccess = (id) => post(`${SETTINGS_BASE_PATH}/collab-access/${id}/block`);
export const unblockCollabAccess = (id) =>
  post(`${SETTINGS_BASE_PATH}/collab-access/${id}/unblock`);
export const getLlmSettings = () => get(`${SETTINGS_BASE_PATH}`);
export const updateLlmSettings = (payload) => patch(`${SETTINGS_BASE_PATH}`, payload);
